import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { AppStateProvider } from './components/AppStateProvider/AppStateProvider';
import Header from './components/Header/Header';
import { MainContent } from './components/MainContent/MainContent';
import { BrandLogo } from './branding/BrandLogo';
import { useBranding } from './branding/BrandingProvider';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appContainer: {
      position: 'relative',
      width: ({ showLogo }: { showLogo: boolean }) => (showLogo ? `calc(100% - ${theme.brandSidebarWidth}px)` : '100%'),
      height: '100%',
      background: theme.backgroundColor,
      overflow: 'hidden',
      [theme.breakpoints.between('md', 1280)]: {
        width: ({ showLogo }: { showLogo: boolean }) =>
          showLogo ? `calc(100% - ${theme.tabletBrandSidebarWidth}px)` : '100%',
      },
      [theme.breakpoints.down('sm') + theme.includeLandscapeMd]: {
        width: '100%',
        overflowY: 'auto',
        // When the logo (and its top bar) is hidden, add a little breathing
        // room so section titles aren't flush against the top of the page.
        paddingTop: ({ showLogo }: { showLogo: boolean }) => (showLogo ? 0 : '2em'),
      },
    },
    brandSidebar: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      right: 0,
      left: `calc(100% - ${theme.brandSidebarWidth}px)`,
      '& img': {
        position: 'absolute',
        right: 24,
        bottom: 40,
        maxWidth: `calc(${theme.brandSidebarWidth}px - 48px)`,
        height: 'auto',
      },
      [theme.breakpoints.between('md', 1280)]: {
        left: `calc(100% - ${theme.tabletBrandSidebarWidth}px)`,
        '& img': {
          maxWidth: `calc(${theme.tabletBrandSidebarWidth}px - 24px)`,
          right: 12,
        },
      },
      [theme.breakpoints.down('sm') + theme.includeLandscapeMd]: {
        display: 'none',
      },
    },
  })
);

function App() {
  const { sidebarColor, showLogo } = useBranding();
  const classes = useStyles({ showLogo });

  return (
    <AppStateProvider>
      <div className={classes.appContainer}>
        <Header />
        <MainContent />
        {showLogo && (
          <div className={classes.brandSidebar} style={{ background: sidebarColor }}>
            <BrandLogo />
          </div>
        )}
      </div>
    </AppStateProvider>
  );
}

export default App;
